var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#planet_svg__clip0_4193_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.64 1.687v0zM12.458 3.15c-.197.14-.422.28-.648.422.226.196.423.393.62.618.14-.225.281-.45.422-.647.169-.309.31-.59.422-.815-.225.112-.506.253-.816.422zm-9.825 7.229a6.144 6.144 0 01-.479-2.391c0-3.207 2.618-5.851 5.856-5.851.844 0 1.633.197 2.365.506 2.195-1.547 3.969-2.25 4.588-1.603 1.014.985-1.323 4.894-5.18 8.748-3.856 3.854-7.77 6.188-8.755 5.175-.619-.618.057-2.39 1.605-4.584zm.929 1.434c-.14.225-.282.45-.422.647-.17.31-.31.59-.423.816.226-.113.507-.253.817-.422.197-.14.422-.281.647-.422a6.431 6.431 0 01-.62-.619zm-1.886 1.829s0-.029.028 0h-.028zm.704.647v.028s-.029 0 0-.028zM14.288 2.362h.028s0 .028-.028 0zM8.01 13.838c-.479 0-.901-.028-1.323-.14a37.299 37.299 0 003.744-3.263 37.3 37.3 0 003.266-3.741c.112.422.168.844.168 1.294 0 3.234-2.646 5.85-5.855 5.85z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "planet_svg__clip0_4193_182"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgPlanet;